export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5092.e22d9e04.jpg";